// extracted by mini-css-extract-plugin
export default {"boardsList":"BoardList_boardsList__5Aa4V"};